import { Injectable } from '@angular/core';
import { AuthUser } from '../models/auth.models';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, lastValueFrom, throwError } from 'rxjs';

import { GlobalComponent } from "../../global-component";
import { TokenStorageService } from './token-storage.service';
import { JwtDecoded } from '../models/jwt-decoded';
import { JwtServiceService } from './jwt-service.service';
import { ActivatedRoute, Router } from '@angular/router';

const AUTH_API = GlobalComponent.AUTH_API;
const API_URL = GlobalComponent.API_URL;

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

@Injectable({ providedIn: 'root' })

/**
 * Auth-service Component
 */
export class AuthenticationService {

    user!: AuthUser;
    currentUserValue: any;
    private currentUserSubject: BehaviorSubject<AuthUser>;
    refreshingToken:boolean = false;

    constructor(private http: HttpClient, private tokenService: TokenStorageService, private jwtService: JwtServiceService,
        private router: Router,private activateRoute: ActivatedRoute) {
        this.currentUserSubject = new BehaviorSubject<AuthUser>(JSON.parse(localStorage.getItem('currentUser')!));
     }

    /**
     * Performs the register
     * @param email email
     * @param password password
     */
     register(email: string, username: string, password: string) {
        // return getFirebaseBackend()!.registerUser(email, password).then((response: any) => {
        //     const user = response;
        //     return user;
        // });

        // Register Api
        return this.http.post(API_URL + 'users', {
            email,
            username,
            password,
          }, httpOptions);
    }

    /**
     * Performs the auth
     * @param email email of user
     * @param password password of user
     */
    login(username: string, password: string) {
        // return getFirebaseBackend()!.loginUser(email, password).then((response: any) => {
        //     const user = response;
        //     return user;
        // });

        return this.http.post(AUTH_API , {
            username,
            password
          }, httpOptions).pipe(catchError(this.handleError));
    }

    /**
     * Returns the current user
     */
    public currentUser(): any {
        let u = <AuthUser>JSON.parse(localStorage.getItem('currentUser')!);
        if(u!= null && u.expired!= undefined)
        {
            if(new Date(u.expired) <new Date())
            {
                this.tokenService.deleteToken();
                this.router.navigate(['/login']);
                return;
            }

            //
            if((new Date(u.expired).getTime()-new Date().getTime()) < 600000 && u.refresh_token && !this.refreshingToken)
            {
                this.refreshingToken = true;
                this.refreshToken(u);
            }
        }

        return <AuthUser>(JSON.parse(localStorage.getItem('currentUser')!));
    }

    async refreshToken(user:AuthUser){
        //Rigenero il token se mancano 10 minuti alla scadenza
        let r = {
            'refresh_token' : user.refresh_token
        }
        let httpResponse =  this.http.post<any>(`${API_URL}token/refresh`,r);
        let newToken = await lastValueFrom(httpResponse);
        let decoded = <JwtDecoded>this.jwtService.DecodeToken(newToken.token);
        user.token = newToken.token;
        user.refresh_token = newToken.refresh_token;
        user.expired = new Date(decoded.exp*1000);
        this.tokenService.saveUser(user);
        this.refreshingToken = false;
    }
    /**
     * Logout the user
     */
    logout() {
        // logout the user
        // return getFirebaseBackend()!.logout();
        this.tokenService.deleteToken();
        this.currentUserSubject.next(null!);
    }

    /**
     * Reset password
     * @param email email
     */
    resetPassword(email: string) {
        /*return getFirebaseBackend()!.forgetPassword(email).then((response: any) => {
            const message = response.data;
            return message;
        });*/
        return '';
    }

    isAdmin(){
        let u = this.currentUser();
        if(u && u.ruoli && u.ruoli.length>0)
        {
            //return u.ruoli.includes("ROLE_ADMIN");
            return true;
        }
        return false;
    }

    isLoggedIn(){
        let logged: boolean = false;
        let u = <AuthUser>JSON.parse(localStorage.getItem('currentUser')!);
        if(u!= null && u.expired!= undefined && new Date(u.expired) >new Date())
        {
            logged = true;
            //
            if((new Date(u.expired).getTime()-new Date().getTime()) < 600000 && u.refresh_token && !this.refreshingToken)
            {
                this.refreshingToken = true;
                this.refreshToken(u);
            }
        }
        return logged;
    }

    private handleError(error: HttpErrorResponse) {
        if (error.status === 0) {
          // A client-side or network error occurred. Handle it accordingly.
          console.error('An error occurred:', error.error);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong.
          console.error(
            `Backend returned code ${error.status}, body was: `, error.error);
        }

        if(error.status == 401)
        {
            return error.message;
        }
        // Return an observable with a user-facing error message.
        return throwError(() => new Error('Something bad happened; please try again later.'));
      }

}

